import React from 'react'

import { Cross as Icon } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import { CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'

import * as styles from './compare-bar-item.module.css'

interface CompareBarItemProps extends CompareVehicle {
  onClose: () => void
}

const CompareBarItem: React.FC<CompareBarItemProps> = ({ title, subtitle, price, onClose }) => {
  return (
    <div className={styles.item}>
      <div className={styles.meta}>
        <Text type={TextStyles.cardTitle} element={'div'} children={title} />
        <Text type={TextStyles.body2} element={'div'} children={subtitle} />
      </div>
      <div>
        <Text type={TextStyles.cardTitle} element={'div'} children={price} />
      </div>
      <div className={styles.close} role="button" tabIndex={0} onClick={onClose} onKeyUp={onClose}>
        <SVG size={22} children={Icon} />
      </div>
    </div>
  )
}

export default CompareBarItem
